import {
  sendOtpToEmail,
  updateEmail,
  verifyEmail
} from "./chunk-B3QVRXFB.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/auth/email.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useSendOtpToEmail = () => {
  return useMutation({
    mutationFn: sendOtpToEmail
  });
};
var useVerifyEmail = ({ lang }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: verifyEmail,
    onSuccess: () => {
      queryClient.setQueryData(["user", { lang }], (oldUser) => {
        if (oldUser) {
          return __spreadProps(__spreadValues({}, oldUser), {
            email_verified: true,
            force_verify_email: false
          });
        }
        return oldUser;
      });
    }
  });
};
var useUpdateEmail = ({ lang }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateEmail,
    onSuccess: (email) => {
      queryClient.setQueryData(["user", { lang }], (oldUser) => {
        if (oldUser) {
          return __spreadProps(__spreadValues({}, oldUser), {
            email
          });
        }
        return oldUser;
      });
    }
  });
};

export {
  useSendOtpToEmail,
  useVerifyEmail,
  useUpdateEmail
};
//# sourceMappingURL=chunk-LYMMZRKM.mjs.map